import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { LoadingChunkFailErrorHandler } from 'ngx-mt-ui-lib/services/loading-chunk-fail-error-handler';
import {
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AuthEffects } from './features/auth/state/auth.effects';
import { authReducer } from './features/auth/state/auth.reducers';
import { APP_BASE_HREF } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { authInitializer } from './core/app-initializers/auth-initializer';
import { themeInitializer } from './core/app-initializers/theme-initializer';
import { getTokenInterceptor } from './core/services/token.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToast } from 'mt-ui-lib/services/toast';
import { PageNotFoundConfig } from 'ngx-mt-ui-lib/components/page-not-found';
import { NoAccessConfig } from 'ngx-mt-ui-lib/components/no-access';
import { provideLibTranslations, ru } from 'ngx-mt-ui-lib/translate';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { translateInitializer } from './core/app-initializers/translate-initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(QuicklinkStrategy),
      withInMemoryScrolling({ anchorScrolling: 'enabled' }),
    ),
    provideHttpClient(withInterceptors([getTokenInterceptor])),
    provideAnimationsAsync(),
    provideStore({ auth: authReducer }),
    ...(isDevMode()
      ? [
          provideStoreDevtools({
            maxAge: 25,
          }),
        ]
      : []),
    provideEffects(AuthEffects),
    {
      provide: ErrorHandler,
      useClass: LoadingChunkFailErrorHandler,
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    Title,
    provideAppInitializer(authInitializer),
    provideAppInitializer(themeInitializer),
    provideAppInitializer(translateInitializer),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
        enforceLoading: true,
      }),
      fallbackLang: 'ru',
      lang: 'ru',
    }),
    provideLibTranslations({
      ru: ru,
      // en: en,
    }),
    ...provideToast({
      duration: 2000,
      // position: 'top right',
      success: { icon: { class: 'mt-icons mt_check-outlined' } },
      info: { icon: { class: 'mt-icons mt_info' } },
      warning: { icon: { class: 'mt-icons mt_info' } },
      error: { duration: 3000, icon: { class: 'mt-icons mt_alarm-thin' } },
    }),
    {
      provide: PageNotFoundConfig,
      useValue: <PageNotFoundConfig>{
        mainUrl: '/main',
      },
    },
    {
      provide: NoAccessConfig,
      useValue: <NoAccessConfig>{
        mainUrl: '/main',
      },
    },
  ],
};
